import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
const _excluded = ["tlds", "onRequestClose"];
import React from 'react';
import { Box, CustomModalLayout, Modal, Text } from '@wix/design-system';
import { DomainSearchGateModule } from '../../module/domainSearchGate.module';
export const VoucherTldsModal = _ref => {
  let tlds = _ref.tlds,
    onRequestClose = _ref.onRequestClose,
    modalProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const _DomainSearchGateModu = DomainSearchGateModule.internals.useTranslations(),
    t = _DomainSearchGateModu.t;
  return /*#__PURE__*/React.createElement(Modal, _extends({}, modalProps, {
    onRequestClose: onRequestClose,
    shouldCloseOnOverlayClick: true
  }), /*#__PURE__*/React.createElement(CustomModalLayout, {
    title: t('domain_search_gate.voucher_banner.tld_tooltip'),
    onCloseButtonClick: onRequestClose,
    width: "480px",
    overflowY: "hidden"
  }, /*#__PURE__*/React.createElement(Box, {
    flexWrap: "wrap",
    gap: "10px",
    maxHeight: "500px",
    overflowY: "auto"
  }, tlds.map(tld => /*#__PURE__*/React.createElement(Box, {
    key: tld,
    borderRadius: "8px",
    backgroundColor: "D75",
    padding: "6px 12px"
  }, /*#__PURE__*/React.createElement(Text, {
    size: "medium"
  }, ".", tld))))));
};
//# sourceMappingURL=VoucherTldsModal.js.map